import React, { useState, useEffect } from 'react';
import Footer from '../../components/footer/Footer';
import SideBanner from '../../components/side-banner/SideBanner';
import AllProduct from '../../components/all-product/AllProduct';
import images from '../../assets/images';
import axiosInstance from '../../Axios';
import Toast from '../../services/Toast';
import Const from '../../config/const';
import Loader from '../../components/loader/Loader';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import { consumeHandoffError } from '../../services/PendingApplication';
import './Home.css';

const Home: React.FC = () => {
  const navigate = useNavigate();
  const [loading , setLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState<any>(null);

  useEffect(() => {
    try {
      const stored = localStorage.getItem('user');
      if (stored) setCurrentUser(JSON.parse(stored));
    } catch {}

    // Raised before the redirect that landed the user here, where the toast
    // could not survive the page load.
    const handoffError = consumeHandoffError();
    if (handoffError) {
      Toast.error(handoffError);
    }
  }, []);
  const logout = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get('/auth/logout');
      setLoading(false);
      if (!response?.data?.status) {
        Toast.error(response.data.message);
        return;
      }
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      Toast.success("Signed out successfully.");
      // Hand off to the app's logout so its session on THIS device ends too
      // (see Navbar.tsx for the same flow).
      if (Const.linentechLogout) {
        window.location.href = Const.linentechLogout;
        return;
      }
      navigate("/");
    } catch (error) {
    }
  };
  if (loading) {
    return (
      <div className="align-items-center d-flex">
        <Loader />
      </div>
    );
  }
  return (
    <>
    <Navbar/>
      <div className="home-container">
        <div className="home-content max-width">
          <div className="home-header">
            <div className="home-header__text">
              <h1 className="home-header__title">Our Products</h1>
              <p className="home-header__subtitle">Select an application to get started with your laundry management solutions</p>
            </div>
            {(currentUser?.role === 1 || currentUser?.role === 2) && (
              <button className="home-manage-users-btn" onClick={() => navigate('/org/users')} data-cy="home-manage-users-btn">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
                Manage Users
              </button>
            )}
          </div>
          <AllProduct />
        </div>
        <Footer />
      </div>
    </>
  );
};

export default Home;
